// extracted by mini-css-extract-plugin
export default {"defaultWrapper":"Detailed__defaultWrapper--16c","defaultLoader":"Detailed__defaultLoader--3K5","item":"Detailed__item--3ka","placeHolderShimmer":"Detailed__placeHolderShimmer--3Cf"};